import { ChoicesAnswer } from '../components/context/SurveyPageContext';

interface collectChooseManyAnswerIdsProps {
  choiceAnswers: ChoicesAnswer[];
}

const collectChooseManyAnswerIds = ({ choiceAnswers }: collectChooseManyAnswerIdsProps): number[] =>
  choiceAnswers
    .filter((answer) => !!answer.choices)
    .map((answer) => answer.choices)
    .flat()
    .map((choice) => choice.id);

export { collectChooseManyAnswerIds };
